// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2wqEm","head":"ProcedureTableInfo_head__qywo7"};